/**
 * Created by SH: 02/20/2020
 */

import { IExpandAnimateConfig } from "./SanEnginePlayer";
import { SanSpriteSymbol} from './Symbol/SanSpriteSymbol';

import { Power3, Power2, gsap } from 'gsap';
import { SanSymbolData } from "./Symbol/SanSymbolData";
import { ReelState } from "../../core/reel/ReelEngineView";
import { Helper } from "../../core/utils/Helper";
import { ReelSymbolStates } from "../../core/reel/symbol/ReelSpriteSymbolArea";
import { SanEngineView } from "./SanEngineView";
import { GameConfig, SanGameMode } from "../config/base/GameConfig";
import { IReelConfig, ReelStopCallbacks } from "../../core/reel/IData/IReelData";
import { SanQuentin2 } from "../SanQuentin2";
import { ArrayHelper } from "../../core/utils/ArrayHelper";
import { ReelBaseSymbol } from "../../core/reel/symbol/ReelBaseSymbol";
import { Revealer } from '../modules/revealer/Revealer';
import { ReelGameData } from "../server/data/ReelGameData";
import { Sequence } from "../../core/displayobject/Sequence";
import { BLEND_MODES } from "pixi.js";
import { TextStyleConfig } from "../config/translate/TextStyleConfig";
import { SanEngineManager } from "./SanEngineManager";
import { SoundManager } from "../config/sound/SoundManager";
import { SoundConfig } from "../config/sound/SoundConfig";

export class SanEngineController extends SanEngineView {

    private gpGraph: PIXI.Graphics;
    private gpSplitGraph: PIXI.Graphics;

    private attention_seq:Sequence;
    private attention_Div:Sequence[];

    private spSlices: PIXI.Sprite[] = [];
    private tlAnim: gsap.core.Timeline;

    private _doubleExpanded: boolean = false;
    private posPoints:PIXI.Sprite[] = [];
    private splitFSTl: gsap.core.Timeline;
    private _lockedBar:PIXI.Sprite;

    private teasing:boolean = false;

    constructor(_ID:number,_config:IReelConfig , initData:any){
        super(_ID, _config,initData);
        this.createExtra();
    }

    public get doubleExpand(): boolean {
        return this._doubleExpanded
    }

    public set doubleExpand(v: boolean) {
        this.isActive = !v;
        this._doubleExpanded = v;
    }

    public get stepPosOffset(): number {
        return 0;//this.state.isIdle ? 0 : this.engine.reverse ? 1 : -1;
    }

    protected createNewSymbol(id: number, symbolName: string, state?: string, type?: number): ReelBaseSymbol { 
        if(state == ReelSymbolStates.NORMAL && symbolName === "X"){
            state = ArrayHelper.getRandomValue(["normal", "normal2", "normal3", "normal4"]);
        }
        const sym = new SanSpriteSymbol(id, symbolName,state,type ? type : 4);
  
        return sym;
    }

    createExtra():void{
        this.posPoints = [];
        
        this.AllWindowSymbols.forEach(sym => {
            const sp = this.addChild(new PIXI.Sprite());
            sp.position = sym.position;
            this.posPoints.push(sp);
        });

        this._lockedBar = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("Reel_Lock")[0]));
        this._lockedBar.anchor.set(0.5,0.5);
        this._lockedBar.position.y = 222;
        this._lockedBar.height = this.maxHeight;
        this._lockedBar.position.x = -this._lockedBar.width;
        this._lockedBar.alpha = 0;

    }

    public playAttentionLand():void{
        if(!this.attention_seq){
            this.attention_seq = SanQuentin2.overlay.addChild(new Sequence(SanQuentin2.assetLoader.getTextures("Reels_Landing")));
            this.attention_seq.blendMode = BLEND_MODES.ADD;
            this.attention_seq.position = Helper.copyLocalPosition(this.attention_seq,this);
            this.attention_seq.position.y = this.maxHeight; 
            this.attention_seq.anchor.set(0.5);
        }
        this.attention_seq.play();
    }

    private attTL:gsap.core.Timeline;
    public playAttentionDiv(apply:boolean):void{
        this.attTL = Helper.setTimeline(this.attTL);

        if(!this.attention_Div){
            this.attention_Div = [];
            for(let k = 0; k < 2 ; k++){
                const divAtt = SanQuentin2.reelEngineManager.addChild(new Sequence(SanQuentin2.assetLoader.getTextures("Anticipation")));
                divAtt.position = this.position;
                divAtt.anchor.set(0.5);
                divAtt.scale.set(1,1.5);
                divAtt.position.x += this.maxWidth/2 + (k%2 ? -this.maxWidth : 0) + 8; // 8 pixles for offset between reels.
                divAtt.position.y = 220;
                divAtt.blendMode = BLEND_MODES.ADD;
                divAtt.zIndex = 2000;
                divAtt.alpha = 0;
                this.attention_Div.push(divAtt);
            }
        }
        if(!apply && !this.attention_Div[0].isActive){
            return;
        }
        if(apply){
            SoundManager.playSoundEffect(SoundConfig.SCATTER_ATTENTION_START,undefined,false);
        }
        this.attention_Div.forEach(seq => {
            this.attTL.fromTo(seq, { alpha: apply ? 0 : 1 }, { alpha: apply ? 1 : 0, duration: 0.225 }, 0);
            if (apply) seq.play({ repeat: -1 })
            else {
                this.attTL.eventCallback("onComplete", () => {
                    seq.stop();
                })
            }
        });
    }

    public reelLocker(close:boolean, duration:number = 0.45){
        if(close == !this._activeReel) return gsap.timeline();
        
        this.tlAnim = Helper.setTimeline(this.tlAnim);

        this.mask = this._maskObject;

        if(close){
            this.tlAnim.to(this._lockedBar, 0.1, {alpha:1},0);
            this.tlAnim.to(this._lockedBar.position, duration, {x:0},0);
            this.tlAnim.add(() => this.mask = null!)
        }else{
            this.tlAnim.to(this._lockedBar.position, duration, {x:-this._lockedBar.width});
            this.tlAnim.to(this._lockedBar, 0.1, {alpha:0},"-=" + 0.1);
        }
        
        this._activeReel = !close;

        return this.tlAnim;
    }

    public parseData(data: ReelGameData): void {

        if(data.raw.mode == SanGameMode.FREESPIN_SETUP2){
            data.reels[this.reelID][0] = "X";
            data.reels[this.reelID][data.reels[this.reelID].length-1] = "X";
        }
        super.parseData(data);
        this.setFSSymbol(data.convictedMysterySymbol, data.convictedMysteryMultiplier)
    };

    private fsSymbol: { sym: string, val: number };
    public setFSSymbol(sym: string, val: number): void {
        if(!this.fsSymbol) this.fsSymbol = { sym: "", val: 0 };
        this.fsSymbol.sym = sym;
        this.fsSymbol.val = val;
    };

    protected addChildObjOrder(): void {
        super.addChildObjOrder();
        this.gpGraph = this.createGraphic();
        this.gpGraph.alpha = 0;
        this.gpSplitGraph = new PIXI.Graphics();
        this.gpSplitGraph.beginFill(0xFFFFFF, 1);
        this.gpSplitGraph.drawRect(-SanSymbolData.DEFAULT_DIM.WIDTH * 0.5, -SanSymbolData.DEFAULT_DIM.HEIGHT * 0.5,
            SanSymbolData.DEFAULT_DIM.WIDTH, this.maxHeight);
        this.gpSplitGraph.endFill();
        this.gpSplitGraph.alpha = 0;

        this.addChild(this.gpSplitGraph);
    }

    protected createMask(): void {
        this._maskObject = this.createGraphic();
        this._maskObject.name = "mask";
    }

    public convertAnim():void{
        const spine = SanQuentin2.overlay.playStandAloneSpine("bonus_effect", { animation: "animation" });
        spine.item.position = Helper.copyLocalPosition(spine.item,this);
        spine.item.position.y += SanSymbolData.DEFAULT_DIM.HEIGHT * 2;
    }

    public applySymbolsFromXWays(_rev:Revealer,isDoubleXways?:boolean):void{
        const rev:Revealer = _rev;
        if(!_rev.isExpanded) return;

        if(isDoubleXways){
            this.removeAllWindowSymbols();
            for(let k = 0; k < 4; k++){
                const sym = this.createNewSymbol(k,rev.revealType) as SanSpriteSymbol;
                sym.forceSplitState(2);
                sym.position.y = sym.posID[0] * SanSymbolData.fetchSymHeightSize(4);
                this.addSymbol(sym);
            }
        }else{
            if(rev.isTop){
                this.AllWindowSymbols.forEach(s => { s.posID[0] += 2});
                for(let k = 0; k < 2; k++){
                    const sym = this.createNewSymbol(k,rev.revealType) as SanSpriteSymbol;
                    sym.position.y = sym.posID[0] * SanSymbolData.fetchSymHeightSize(4);
                    if(this.fsSymbol && sym.symName == this.fsSymbol.sym) sym.isSpecial(this.fsSymbol.val,0)
                    sym.forceSplitState(2);
                    this.addSymbol(sym);
                }
            }else{
                const startPos = ArrayHelper.fetchLastValue(this.AllWindowSymbols).posID[0]+1;
                for(let k = startPos; k < startPos+2; k++){
                    const sym = this.createNewSymbol(k,rev.revealType) as SanSpriteSymbol;
                    sym.position.y = (k-2) * SanSymbolData.fetchSymHeightSize(4);
                    if(this.fsSymbol && sym.symName == this.fsSymbol.sym) sym.isSpecial(this.fsSymbol.val,0)
                    sym.forceSplitState(2);
                    this.addSymbol(sym);
                }
            }
        }
        _rev.xWaysReset();
    }

    public splitFsLand(duration: number, lvl: number = 1): gsap.core.Timeline {
        this.splitFSTl = Helper.setTimeline(this.splitFSTl);
        this.splitFSTl.fromTo(this.gpSplitGraph, duration, { alpha: 1 }, { alpha: 0, ease: Power3.easeOut as any });

        for (let k: number = 0; k < (this.spSlices.length / 2 * lvl); k++) {
            this.splitFSTl.add(() => {
                const lvlDimFactor: number = lvl;
                const lvlYOffset: number = lvl == 1 ? 45 : 45 + 45 / 2;
                this.spSlices[k].visible = true;
                this.spSlices[k].position.y = -lvlYOffset + (((SanSymbolData.DEFAULT_DIM.HEIGHT / (2 * lvl))) * k);
                this.spSlices[k].scale.set(1, 1 / lvlDimFactor);
            }, 0);
            this.splitFSTl.fromTo(this.spSlices[k], duration, { alpha: 1 }, { alpha: 0.15 }, 0)
        }

        return this.splitFSTl;
    }

    public stopFsLand(duration: number = 0.45): gsap.core.Timeline {
        this.splitFSTl = Helper.setTimeline(this.splitFSTl, {
            onComplete: () => this.spSlices.forEach(s => s.visible = false)
        });

        for (let k: number = 0; k < this.spSlices.length; k++) {
            if (this.spSlices[k].visible)
                this.splitFSTl.fromTo(this.spSlices[k], duration, { alpha: 1 }, { alpha: 0 }, 0)
        }

        return this.splitFSTl;
    }

    public changeAlpha(alpha: number, duration: number): gsap.core.Timeline {
        if (this.isActive && this.gpGraph.alpha == alpha) return gsap.timeline();
        this.tlAnim = Helper.setTimeline(this.tlAnim);
        this.tlAnim.to(this.gpGraph, {duration:duration, alpha: alpha });
        return this.tlAnim;
    }

    public onExpandSymbol(data: IExpandAnimateConfig): gsap.core.Timeline {

        const tl = gsap.timeline();

        if (data.duration == undefined) 
            data.duration = this.config.DURATION.EXPAND;
        
        tl.add(this.engine.ExpandSymbolSQ(data, this._symbolContainer, this.currentWindowAmount),0);

        this.AllWindowSymbols.forEach(s => {
            let toSize = Math.floor(data.shrink ? s.sizeType.value/2 : s.sizeType.value*2);
            tl.add(s.changeState({
                state: ReelSymbolStates.NORMAL,
                forceState: true,
                sizeType: toSize,
                ease: GameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND,
                duration: data.duration!,
            }),0);
        })
        
        this.engine.activateNextAnimation();

        return tl;
    }
 
    public changeToSetup(enable:boolean):void{
        this.config.WINDOW_AMOUNT = enable ? 3 : 4;
        this.config.DIM.HEIGHT = this.config.WINDOW_AMOUNT *  (enable ? 198 : 148) 
        this._engine.stepDistance = this.currentStepDistance;

        this._symbolContainer.y = enable ? 23 : 0;

        this.AllSymbols.forEach(s => s.remove());
        this._symbolContainer.removeChildren();

        this.initReel();
    }

    protected onStopStarted(): void {
        if(!this.teasing){
            super.onStopStarted();
        }else{
            for (var i = 0; i < this.AllSymbols.length; i++) {
                this.tryChangeState(this.AllSymbols[i],{
                    state: ReelSymbolStates.NORMAL,
                    duration: this.stopDuration,
                    ease: Power2.easeInOut
                })
            }
            Helper.triggerIfExist(this.stopCallbacks.stops);
        }
    }

    public createStop(cb?:ReelStopCallbacks, isTeaser:boolean = false): gsap.core.Timeline {
        this.stopCallbacks = cb ? cb : {};
        this.teasing = isTeaser;
        if (this.isActive) {
            return this.createNextAnimation(() => isTeaser ? this.engine.StopTeaser2(1) : this.engine.Stop(this.stopDuration, this.stopEase));
        }
        this.setCurrentReelSet();
        return this.createNextAnimation(() => this.engine.Idle(), ReelState.INACTIVE);
    }

    public createChokoStop(cb?:ReelStopCallbacks,isTeaser:boolean = false): gsap.core.Timeline {
        this.stopCallbacks = cb ? cb : {};
        return this.createNextAnimation(() => isTeaser ? this.engine.StopTeaser2(1) : this.engine.Stop(this.config.DURATION.CHOKO_STOP, this.config.EASING.CHOKO_STOP));
    }

    symPosPointer(symPos:number):PIXI.Sprite{
        return this.posPoints[symPos];
    }

    onResize(): void {
        super.onResize();
        this.AllSymbols.forEach(s => s.onResize() );
    }

}